import { unparse } from 'papaparse';

export type CsvValue = string | number | boolean | null | undefined;

// Cells that spreadsheet programs could read as formulas. A pattern, not papaparse's own `true`: that
// one misses a formula string that contains a line break. Only strings are prefixed: a negative
// NUMBER stays a number.
const ESCAPE_FORMULAE = /^[=+\-@\t\r]/;

export const convertToCSV = (data: Array<Record<string, CsvValue>>): string => {
  // Prefix cells that spreadsheet programs could interpret as formulas. Ticker,
  // sector, and order labels originate outside the browser and must stay data.
  return unparse(data, { escapeFormulae: ESCAPE_FORMULAE });
};

/** Rows of any length, written as given: for files that stack several labeled tables. */
export const convertRowsToCSV = (rows: CsvValue[][]): string => {
  return unparse(rows, { escapeFormulae: ESCAPE_FORMULAE });
};

export const downloadCSV = (csvData: string, filename = 'data.csv'): void => {
  const safeFilename = filename.toLowerCase().endsWith('.csv') ? filename : `${filename}.csv`;
  // UTF-8 BOM keeps Excel from misreading non-ASCII ticker/company metadata.
  const blob = new Blob(['\uFEFF', csvData], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', safeFilename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    // Revoking synchronously can cancel the download in Safari/Firefox, which capture
    // the blob after the click task. Release it on the next turn instead.
    setTimeout(() => URL.revokeObjectURL(url), 0);
  }
};
